import _ from 'lodash'

import commomMinxin from './commom'
/* eslint-disable */
export default {
    mixins: [commomMinxin],
    computed: {
        isTenantApp() {
            return this.$store.state.modeling.app.isTenant
        },
        validPurviewService() {
            return this.$store.state.modeling.validPurview.service || {}
        },
        validPurviewObject() {
            return this.$store.state.modeling.validPurview.object || {}
        },
    },
    watch: {
        'apiParamObj.url': {
            immediate: true,
            handler(val) {
                if (val) {
                    const pathReg = /(\/\{([0-9a-z\-\{\.\_}]*)\})/gi
                    const match = val.match(pathReg) || []
                    const pathVar = match.map(item => item.replace(/(\/\{)|(\})/gi, ''))
                    this.getPathParam && this.getPathParam(pathVar.filter(item => !_.isEmpty(item)))
                }
               
            }
        },
        'apiParamObj.response.dataType': {
            handler(val) {
                if (val.dataType !== 'object' && val.dataType !== 'objectArray') {
                    delete this.apiParamObj.response.objectId
                }
            }
        }
    },
}
